import api, { endpoints } from '@utils/api';

/**
 * Active permission pages (for role matrix). Backend: GET /permission-pages/active
 */
export const getActivePermissionPages = async () => {
  const response = await api.get(`${endpoints.permissionPages}/active`);
  const data = response.data?.data;
  return Array.isArray(data) ? data : [];
};
